"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const report_processor_1 = require("./report-processor");
class ReportProcessorPage extends report_processor_1.ReportProcessor {
    static decodeStatsParams(statsParams) {
        return Object.assign(super.decodeStatsParams(statsParams), {
            offset: statsParams.offset,
            rows: statsParams.rows
        });
    }
    encodeStatsParams(reportParams) {
        const statsParams = super.encodeStatsParams(reportParams);
        statsParams.offset = reportParams.offset;
        statsParams.rows = reportParams.rows;
        return statsParams;
    }
}
exports.ReportProcessorPage = ReportProcessorPage;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVwb3J0LXByb2Nlc3Nvci1wYWdlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb2Nlc3NvcnMvcmVwb3J0LXByb2Nlc3Nvci1wYWdlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBRUEseURBQXFEO0FBRXJELHlCQUEwQyxTQUFRLGtDQUFlO0lBRXJELE1BQU0sQ0FBQyxpQkFBaUIsQ0FBQyxXQUFnQjtRQUNqRCxNQUFNLENBQUMsTUFBTSxDQUFDLE1BQU0sQ0FBQyxLQUFLLENBQUMsaUJBQWlCLENBQUMsV0FBVyxDQUFDLEVBQUU7WUFDekQsTUFBTSxFQUFFLFdBQVcsQ0FBQyxNQUFNO1lBQzFCLElBQUksRUFBRSxXQUFXLENBQUMsSUFBSTtTQUN2QixDQUFDLENBQUM7SUFDTCxDQUFDO0lBRU0saUJBQWlCLENBQUMsWUFBNkI7UUFDcEQsTUFBTSxXQUFXLEdBQVEsS0FBSyxDQUFDLGlCQUFpQixDQUFDLFlBQVksQ0FBQyxDQUFDO1FBRS9ELFdBQVcsQ0FBQyxNQUFNLEdBQUcsWUFBWSxDQUFDLE1BQU0sQ0FBQztRQUN6QyxXQUFXLENBQUMsSUFBSSxHQUFHLFlBQVksQ0FBQyxJQUFJLENBQUM7UUFFckMsTUFBTSxDQUFDLFdBQVcsQ0FBQztJQUNyQixDQUFDO0NBRUY7QUFsQkQsa0RBa0JDIn0=